'use client';

// npm packages
import React, { useEffect, useState, useRef } from 'react';
import classNames from 'classnames';

// components
import { useDispatch } from 'react-redux';
import { openRemoveAllSuccessModal } from '@/redux/reducers/cart-modal-reducer';
import Button from '../Button';
import Text from '../Text';
import Icon from '../Icon';

function CartItemRemoveAllConfirmModal({ onView, onClose }) {
  const dispatch = useDispatch();
  const [openModal, setOpenModal] = useState(onView);
  const modalRef = useRef(null);

  const handleClose = (data) => {
    setOpenModal(false);
    setTimeout(() => {
      if (data === 'remove') {
        dispatch(openRemoveAllSuccessModal({ type: 'all' }));
      }
      onClose(data, false);
    }, 500);
  };

  useEffect(() => {
    if (onView) {
      setTimeout(() => {
        setOpenModal(true);
        document.body.style.overflow = 'hidden';
      }, 100);
    } else {
      setOpenModal(false);
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [onView]);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        handleClose();
      }
    };

    if (openModal) {
      document.addEventListener('mousedown', handleOutsideClick);
    }

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [openModal]);

  return (
    <div
      className={classNames(
        'w-full h-full bg-black/30 flex items-center justify-center opacity-0 -z-10 transition-all duration-300 fixed inset-0',
        { '!opacity-100 !z-[501]': openModal },
      )}
    >
      <div
        ref={modalRef}
        className={classNames(
          `w-full max-w-[348px] md:!min-w-[480px] relative rounded-[4px] sm:rounded-[12px] transition-all duration-[400ms]`,
        )}
      >
        <div className="mb-12">
          <Icon
            type="close"
            color="#fff"
            onClick={() => handleClose(false)}
            className="cursor-pointer ml-auto"
          />
        </div>
        <div className="bg-white p-16 md:p-24 rounded-xl shadow-cannot-be-added-modal">
          <Text
            type="sub_title"
            className="text-18 lg:text-20 text-chokecherry text-center font-encode-sans font-semibold leading-28 tracking-[0.36px] lg:tracking-[0.4px] mb-10 md:mb-16"
          >
            Remove All Items
          </Text>
          <Text
            type="sub_title"
            className="text-14 lg:text-16 text-coarse-wool text-center font-encode-sans font-medium leading-20 tracking-[0.28px] lg:tracking-[0.32px] mb-20 md:mb-24"
          >
            Do you want to remove all items from your cart?
          </Text>
          <div className="flex justify-between items-center gap-[16px]">
            <Button
              type="outline"
              className="w-full max-w-[208px] h-[36px] lg:h-[40px] !px-16 !py-8 !border-pacific-queen"
              onClick={() => handleClose('remove')}
            >
              <Text
                type="paragraph"
                className="text-pacific-queen text-center text-14 lg:text-16 font-encode-sans font-semibold leading-20 tracking-[0.28px] sm:tracking-[0.32px]"
              >
                Remove
              </Text>
            </Button>
            <Button
              type="outline"
              className="w-full max-w-[208px] h-[36px] lg:h-[40px] !bg-pacific-queen !px-16 !py-8 !border-pacific-queen"
              onClick={() => handleClose('keep')}
            >
              <Text
                type="paragraph"
                className="text-white text-center text-14 lg:text-16 font-encode-sans font-semibold leading-20 tracking-[0.28px] sm:tracking-[0.32px]"
              >
                No, Keep It
              </Text>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CartItemRemoveAllConfirmModal;
